var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoDisable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.0703125,
    width: 45,
    height: 45,
    rx: 22.5,
    fill: "#F0F2FD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.0074 19.2168H15.563V27.2168H26.0074V19.2168ZM27.1362 23.2168L29.563 25.4919V20.9417L27.1362 23.2168ZM30.563 18.6335V27.8001L27.0074 24.4668V27.3835C27.0074 27.8418 26.6074 28.2168 26.1185 28.2168H15.4519C14.963 28.2168 14.563 27.8418 14.563 27.3835V19.0501C14.563 18.5918 14.963 18.2168 15.4519 18.2168H26.1185C26.6074 18.2168 27.0074 18.5918 27.0074 19.0501V21.9668L30.563 18.6335Z",
    fill: "#707070"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3241 15.2462C15.1451 15.4252 15.1451 15.7154 15.3241 15.8944L30.2323 30.8026C30.4112 30.9816 30.7014 30.9816 30.8804 30.8026C31.0594 30.6236 31.0594 30.3334 30.8804 30.1544L15.9723 15.2462C15.7933 15.0672 15.5031 15.0672 15.3241 15.2462Z",
    fill: "#707070"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoDisable);
export default __webpack_public_path__ + "static/media/videoDisable.f32a4e0807e8a44cd3224568d423a5f8.svg";
export { ForwardRef as ReactComponent };